module.exports = __webpack_public_path__ + "img/list_Character_sq_19.e49a1a4f.jpeg";